import React from 'react';
import { Box } from '@waglabs/box';
import { Flex } from '@waglabs/flex';
export const Carousel = ({ variant = 'slider', children, containerProps, ...rest }) => {
    if (variant === 'slider') {
        return (React.createElement(Box, Object.assign({ overflowX: "hidden", width: 1 }, rest),
            React.createElement(Flex, { width: 1, justifyContent: "space-between", alignItems: "center", boxSizing: "border-box", position: "relative" },
                React.createElement(Flex, Object.assign({ overflowX: "scroll", overflowY: "hidden", px: "16px", width: 1, webkitOverflowScroll: "touch" }, containerProps), children))));
    }
    else {
        // TODO: Support "buttons" variant (see HomePageReviewCarousel in wag-gatsby)
        return null;
    }
};
